"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.areCancellationPoliciesSameOrBetter = void 0;
var date_1 = require("./date");
function areCancellationPoliciesSameOrBetter(leftPolicies, rightPolicies) {
    if (leftPolicies.length !== rightPolicies.length) {
        return false;
    }
    var sortedLeftPolicies = sortPoliciesByStartDate(mapToPoliciesWithDates(leftPolicies));
    var sortedRightPolicies = sortPoliciesByStartDate(mapToPoliciesWithDates(rightPolicies));
    return sortedLeftPolicies.every(function (leftPolicy, idx) { return isPolicySameOrBetter(leftPolicy, sortedRightPolicies[idx]); });
}
exports.areCancellationPoliciesSameOrBetter = areCancellationPoliciesSameOrBetter;
function mapToPoliciesWithDates(policies) {
    return policies.map(function (policy) {
        var end = new Date(policy.end);
        var start = policy.nights === 0 ?
            date_1.subDays(end, 1) :
            new Date(policy.start);
        return __assign(__assign({}, policy), { start: start,
            end: end });
    });
}
function sortPoliciesByStartDate(policies) {
    return policies.sort(function (a, b) { return a.start.getDate() - b.start.getDate(); });
}
function isPolicySameOrBetter(leftPolicy, rightPolicy) {
    // policy starts the same day or later
    return leftPolicy.start >= rightPolicy.start &&
        (
        // neither have nights penalty
        (!leftPolicy.nights && !rightPolicy.nights) ||
            // both have nights, left has less nights penalty
            !!(leftPolicy.nights && rightPolicy.nights && leftPolicy.nights <= rightPolicy.nights)) &&
        (
        // neither have percent penalty
        (!leftPolicy.percent && !rightPolicy.percent) ||
            // both have percent, left has less percent penalty
            !!(leftPolicy.percent && rightPolicy.percent && leftPolicy.percent <= rightPolicy.percent)) &&
        (
        // neither have cancellation fee
        (!leftPolicy.amount && !rightPolicy.amount) ||
            // both have fee, left has less amount cancellation fee
            !!(leftPolicy.amount && rightPolicy.amount && leftPolicy.amount <= rightPolicy.amount));
}
